module.exports = __webpack_public_path__ + "img/F.Sc (Medical).7c31b411.svg";